<template>

  <v-card>
    <toolbar medium>
      <template v-slot:head>
        {{ $t(`monitoring.monitoringFunctionName.${name}`) }}
      </template>

      <template v-slot:controls>
        <v-btn depressed small @click="calibration = true">
          <v-icon>perm_data_setting</v-icon> {{ $t('calibrate-references') }}
        </v-btn>
        <v-btn depressed small @click="learn()">
          <template v-if="idle"><v-icon>play_arrow</v-icon> {{ $t('start-learning') }}</template>
          <template v-if="!idle"><v-icon>refresh</v-icon> {{ $t('restart-learning') }}</template>
        </v-btn>
        <v-btn depressed small v-if="!idle" @click="stop()">
          <v-icon>stop</v-icon> {{ $t('pause') }}
        </v-btn>
      </template>
    </toolbar>


    <v-list v-if="calibration">
      <h4>&ensp;{{ $t('calibration-settings') }}</h4>

      <v-list-item>
        <date-range-picker v-model="interval" :time="true" @change="calculateReferences()"></date-range-picker>
      </v-list-item>

      <v-list-item class="align-end">
        <v-list-item-action>
          <v-btn small @click="calibration = false">{{ $t('close') }}</v-btn>
        </v-list-item-action>

        <v-list-item-action>
          <v-btn small color="primary" @click="save()">{{ $t('calibrate') }}</v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <state-idle v-if="idle"></state-idle>
    <state-active v-if="active || calibration" :definition="definition" :values="values.referenceResults" :previous="previous"></state-active>
    <state-learning v-if="learning"></state-learning>
  </v-card>

</template>

<script>
  import moment from 'moment'
  import States from './states.es6'
  import StateLearning from './state-learning'
  import StateActive from './state-active'
  import StateIdle from './state-idle'
  import DateRangePicker from '../../../shared/components/date-range-picker'
  import Toolbar from '../../../shared/toolbar'

  export default {
    name: 'monitoring-item',

    props: [ 'definition', 'name', 'asset' ],

    data () {
      return {
        calibration: false,
        interval: {},
        previous: {},
      }
    },

    computed: {
      values () {
        return this.asset.monitoringConfig[this.name]
      },

      samples () {
        return this.asset.monitoringSamples[this.name]
      },

      idle () {
        return this.values.status === States.IDLE
      },

      active () {
        return this.values.status === States.ACTIVE
      },

      learning () {
        return this.values.status === States.LEARNING
      }
    },

    methods: {
      learn () {
        this.values.status = States.LEARNING
        this.values.learningStartedAt = new Date()

        this.$emit('change', this.values)
      },

      stop () {
        this.values.status = States.IDLE

        this.$emit('change', this.values)
      },

      async save () {
        await this.calculateReferences()

        this.values.status = States.ACTIVE

        this.values.referenceResults = Object.keys(this.values.referenceResults).reduce((values, name) => {
          const temp = this.previous[name] || {}

          const low = temp[0] || 0
          const high = temp[1] || 0
          return { ...values, [name]: [low, high] }
        }, {})

        this.calibration = false
        this.$emit('change', this.values)
      },

      async calculateReferences () {
        const result = await this.$store.dispatch('calculateMonitoringReferenceValues', {
          assetId: this.asset.id,
          timeFrom: moment(this.interval.from).format(),
          timeTo: moment(this.interval.to).format(),
          monitoringFunctionName: this.name
        })

        this.previous = result.data
      },
    },

    created () {
      this.interval = {
        from: this.values.learningStartedAt || new Date(),
        to: new Date()
      }
    },

    watch: {
      calibration (value) {
        value && this.calculateReferences()
      }
    },

    components: {
      Toolbar,
      DateRangePicker,
      StateIdle,
      StateActive,
      StateLearning
    },
  }
</script>

<style scoped lang="scss">

</style>
